var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _g, _g2, _g3, _g4, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationGroupMolecules2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 115,
    viewBox: "0 0 159 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 115.468,
    cy: 18.4667,
    r: 14.0555,
    transform: "rotate(23.2838 115.468 18.4667)",
    fill: "#AABFA7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.468,
    cy: 18.4667,
    r: 14.0555,
    transform: "rotate(23.2838 115.468 18.4667)",
    fill: "url(#paint0_radial_679_2052)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.2689,
    cy: 68.3116,
    r: 14.0555,
    transform: "rotate(23.2838 91.2689 68.3116)",
    fill: "#AABFA7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.2689,
    cy: 68.3116,
    r: 14.0555,
    transform: "rotate(23.2838 91.2689 68.3116)",
    fill: "url(#paint1_radial_679_2052)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.2689,
    cy: 85.5333,
    r: 14.0555,
    transform: "rotate(23.2838 91.2689 85.5333)",
    fill: "#AABFA7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.2689,
    cy: 85.5333,
    r: 14.0555,
    transform: "rotate(23.2838 91.2689 85.5333)",
    fill: "url(#paint2_radial_679_2052)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.0697,
    cy: 44.5293,
    r: 14.0555,
    transform: "rotate(23.2838 83.0697 44.5293)",
    fill: "#AABFA7"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.0697,
    cy: 44.5293,
    r: 14.0555,
    transform: "rotate(23.2838 83.0697 44.5293)",
    fill: "url(#paint3_radial_679_2052)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.5502,
    cy: 24.8474,
    r: 14.0555,
    transform: "rotate(23.2838 94.5502 24.8474)",
    fill: "#AABFA7"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.5502,
    cy: 24.8474,
    r: 14.0555,
    transform: "rotate(23.2838 94.5502 24.8474)",
    fill: "url(#paint4_radial_679_2052)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.031,
    cy: 51.91,
    r: 14.0555,
    transform: "rotate(23.2838 106.031 51.91)",
    fill: "#AABFA7"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.031,
    cy: 51.91,
    r: 14.0555,
    transform: "rotate(23.2838 106.031 51.91)",
    fill: "url(#paint5_radial_679_2052)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.535,
    cy: 26.4876,
    r: 14.0555,
    transform: "rotate(23.2838 126.535 26.4876)",
    fill: "#AABFA7"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.535,
    cy: 26.4876,
    r: 14.0555,
    transform: "rotate(23.2838 126.535 26.4876)",
    fill: "url(#paint6_radial_679_2052)"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.21,
    cy: 34.6884,
    r: 14.0555,
    transform: "rotate(23.2838 105.21 34.6884)",
    fill: "#AABFA7"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.21,
    cy: 34.6884,
    r: 14.0555,
    transform: "rotate(23.2838 105.21 34.6884)",
    fill: "url(#paint7_radial_679_2052)"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.0555,
    cy: 68.0555,
    r: 14.0555,
    fill: "#AABFA7"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.0555,
    cy: 68.0555,
    r: 14.0555,
    fill: "url(#paint8_radial_679_2052)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_679_2052)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 61.0523,
    cy: 65.4926,
    r: 5.86297,
    transform: "rotate(23.2838 61.0523 65.4926)",
    fill: "#45756E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.0523,
    cy: 65.4926,
    r: 5.86297,
    transform: "rotate(23.2838 61.0523 65.4926)",
    fill: "url(#paint9_radial_679_2052)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bf_679_2052)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57.0555,
    cy: 68.0555,
    r: 14.0555,
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_679_2052)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.1069,
    cy: 75.1069,
    r: 7.1069,
    fill: "#AABFA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1069,
    cy: 75.1069,
    r: 7.1069,
    fill: "url(#paint10_radial_679_2052)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_679_2052)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.1294,
    cy: 73.811,
    r: 2.9645,
    transform: "rotate(23.2838 13.1294 73.811)",
    fill: "#45756E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.1294,
    cy: 73.811,
    r: 2.9645,
    transform: "rotate(23.2838 13.1294 73.811)",
    fill: "url(#paint11_radial_679_2052)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_bf_679_2052)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.1069,
    cy: 75.1069,
    r: 7.1069,
    fill: "#45756E",
    fillOpacity: 0.1
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_679_2052)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.6069,
    cy: 103.607,
    r: 9.6069,
    fill: "#AABFA7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.6069,
    cy: 103.607,
    r: 9.6069,
    fill: "url(#paint12_radial_679_2052)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_679_2052)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50.3391,
    cy: 101.855,
    r: 4.00732,
    transform: "rotate(23.2838 50.3391 101.855)",
    fill: "#45756E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.3391,
    cy: 101.855,
    r: 4.00732,
    transform: "rotate(23.2838 50.3391 101.855)",
    fill: "url(#paint13_radial_679_2052)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_bf_679_2052)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.6069,
    cy: 103.607,
    r: 9.6069,
    fill: "#45756E",
    fillOpacity: 0.1
  })))), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.835,
    cy: 76.5124,
    r: 14.0555,
    transform: "rotate(23.2838 138.835 76.5124)",
    fill: "#AABFA7"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.835,
    cy: 76.5124,
    r: 14.0555,
    transform: "rotate(23.2838 138.835 76.5124)",
    fill: "url(#paint14_radial_679_2052)"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.835,
    cy: 57.6506,
    r: 14.0555,
    transform: "rotate(23.2838 138.835 57.6506)",
    fill: "#AABFA7"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.835,
    cy: 57.6506,
    r: 14.0555,
    transform: "rotate(23.2838 138.835 57.6506)",
    fill: "url(#paint15_radial_679_2052)"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.476,
    cy: 41.249,
    r: 14.0555,
    transform: "rotate(23.2838 140.476 41.249)",
    fill: "#AABFA7"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.476,
    cy: 41.249,
    r: 14.0555,
    transform: "rotate(23.2838 140.476 41.249)",
    fill: "url(#paint16_radial_679_2052)"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.234,
    cy: 84.7132,
    r: 14.0555,
    transform: "rotate(23.2838 114.234 84.7132)",
    fill: "#AABFA7"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.234,
    cy: 84.7132,
    r: 14.0555,
    transform: "rotate(23.2838 114.234 84.7132)",
    fill: "url(#paint17_radial_679_2052)"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.234,
    cy: 65.8514,
    r: 14.0555,
    transform: "rotate(23.2838 114.234 65.8514)",
    fill: "#AABFA7"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.234,
    cy: 65.8514,
    r: 14.0555,
    transform: "rotate(23.2838 114.234 65.8514)",
    fill: "url(#paint18_radial_679_2052)"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.874,
    cy: 47.8096,
    r: 14.0555,
    transform: "rotate(23.2838 115.874 47.8096)",
    fill: "#AABFA7"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.874,
    cy: 47.8096,
    r: 14.0555,
    transform: "rotate(23.2838 115.874 47.8096)",
    fill: "url(#paint19_radial_679_2052)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_679_2052",
    x: 49.1875,
    y: 53.6281,
    width: 23.7305,
    height: 23.7289,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_679_2052"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bf_679_2052",
    x: 38,
    y: 49,
    width: 38.1094,
    height: 38.111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_679_2052"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_679_2052",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect2_foregroundBlur_679_2052"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_679_2052",
    x: 0,
    y: 64,
    width: 22.2148,
    height: 22.2138,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_679_2052"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_679_2052",
    x: 4.16406,
    y: 64.8458,
    width: 17.9297,
    height: 17.9305,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_679_2052"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_bf_679_2052",
    x: -1,
    y: 63,
    width: 24.2148,
    height: 24.2138,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_679_2052"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_679_2052",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect2_foregroundBlur_679_2052"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_679_2052",
    x: 37,
    y: 93,
    width: 21.2148,
    height: 21.2138,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_679_2052"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_679_2052",
    x: 40.332,
    y: 91.8468,
    width: 20.0156,
    height: 20.0167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_679_2052"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_bf_679_2052",
    x: 33,
    y: 89,
    width: 29.2148,
    height: 29.2138,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_679_2052"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_679_2052",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect2_foregroundBlur_679_2052"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_679_2052",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.361 12.8569) rotate(44.1659) scale(22.1601 22.8407)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_679_2052",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.1614 62.7018) rotate(44.1659) scale(22.1601 22.8407)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_679_2052",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.1614 79.9235) rotate(44.1659) scale(22.1601 22.8407)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_679_2052",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.9622 38.9195) rotate(44.1659) scale(22.1601 22.8407)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_679_2052",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88.4426 19.2376) rotate(44.1659) scale(22.1601 22.8407)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_679_2052",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(99.9231 46.3002) rotate(44.1659) scale(22.1601 22.8407)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_679_2052",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120.427 20.8778) rotate(44.1659) scale(22.1601 22.8407)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_679_2052",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(99.1028 29.0786) rotate(44.1659) scale(22.1601 22.8407)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_679_2052",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.948 62.4457) rotate(44.1659) scale(22.1601 22.8407)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_679_2052",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.4415 57.613) rotate(61.1678) scale(16.0676 7.56987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_679_2052",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.01876 72.2704) rotate(44.1659) scale(11.2048 11.549)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_679_2052",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.798 69.8269) rotate(61.1678) scale(8.12428 3.82756)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_679_2052",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.4324 99.7726) rotate(44.1659) scale(15.1464 15.6116)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_679_2052",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1876 96.4695) rotate(61.1678) scale(10.9822 5.17399)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_679_2052",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(132.728 70.9026) rotate(44.1659) scale(22.1601 22.8407)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_679_2052",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(132.728 52.0408) rotate(44.1659) scale(22.1601 22.8407)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_679_2052",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(134.368 35.6392) rotate(44.1659) scale(22.1601 22.8407)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_679_2052",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.126 79.1034) rotate(44.1659) scale(22.1601 22.8407)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_679_2052",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.126 60.2416) rotate(44.1659) scale(22.1601 22.8407)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_679_2052",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.767 42.1998) rotate(44.1659) scale(22.1601 22.8407)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationGroupMolecules2);
export default __webpack_public_path__ + "static/media/illustration-group-molecules-2.41af7aec0cddb0e82acd11f8d1895659.svg";
export { ForwardRef as ReactComponent };